import React, { useState,useEffect } from "react";
import "../Myprojects.css";
import  { FILES_URL } from '../../../../configs/AppConfig';
import { MdOutlineSlowMotionVideo } from "react-icons/md";

const ResourcesTr = ({data}) => {
   const [resources , setResources] = useState([]);
  useEffect(() => {
              setResources(data.resources)
              // setImgs(data.model3d?.imgs)
        }, [data]);

  console.log(data,"resources")
  // const selectSkip =(id)=>{
  //      setSelectedCardId(id)
  //     }

  //   const openPage = (url) => {
  //   window.open(`/VOXEL_Labs_Projectile_Game.html`, "_blank"); // new tab
  //   // OR window.location.href = "/game.html"; // same tab
  // };
    const openPage = (resource) => {
      if (resource.type === 'HTML') {
    window.open(`${FILES_URL}${resource.url}`, "_blank"); 
      }
      else if (resource.type === 'LINK') {
        window.open(`${resource.url}`, "_blank"); 
      }
  };



  return (
       <div className="h-full w-full">
      {/* <Header /> */}
      <div className="resources-container ">
              {resources.map(resource =>
              <div 
              // onClick={() => selectSkip(resource.id)} 
              className="card-container ">
                <div className="iconH2" >
                  <MdOutlineSlowMotionVideo className="iconImg" />
                  <h2 className="h2Card">{resource.name}</h2>
                </div>
                <p className="pcard">{resource.description}</p>
                <button className="btn-card" onClick={() => openPage(resource)}>view</button>

          </div>
        )} 
        </div>
    </div>
  );
};

export default ResourcesTr;
